import isEmpty from 'lodash.isempty';
import { defineStore } from 'pinia';

export const useLphsStore = defineStore('lphs', {
  state: () => {
    return {
      currentPointCode: '',
      info: {},
    };
  },
  getters: {
    getReEnrichmentData: state => {
      const reqs = state.info[state.currentPointCode]?.reqs;
      if (isEmpty(reqs)) return {};

      return {
        reqs: {
          req_broken: reqs.req_broken,
          req_code_oktmo: reqs.req_code_oktmo,
          req_date_stamp: reqs.req_date_stamp,
          req_delete_mark: reqs.req_delete_mark,
          req_ext_approved: reqs.req_ext_approved,
          req_number_epk: reqs.req_number_epk,
          req_user: reqs.req_user,
        },
      };
    },
  },
  actions: {
    clearInfo() {
      this.info = {};
    },
  },
});
